import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['viewLearningJourneyBtn']
  static values = {
    companyId: Number,
    jwt: String,
    mandatedJourneyUrl: String,
  }

  viewLearningJourneyBtnTargetConnected(viewLearningJourneyBtn) {
    const companyId = this.companyIdValue
    const mandatedJourneyUrl = this.mandatedJourneyUrlValue

    fetch(mandatedJourneyUrl,
      { method: 'GET', headers: { 'Accept': 'application/json', 'Authorization': `Bearer ${this.jwtValue}` } }
    ).then(async (response) => {
      if (response.ok) {
        const data = await response.json()
        const journeyUrl = new URL(`/companies/${companyId}/journeys/${data.id}?smart_recommendations=true`, window.location.origin)
        journeyUrl.searchParams.set('page_url', window.location.href)
        viewLearningJourneyBtn.setAttribute('href', journeyUrl.toString())
        viewLearningJourneyBtn.classList.remove('disabled')
      } else if (response.status === 404) {
        viewLearningJourneyBtn.classList.add('create-learning-journey-btn')
        const createMandatedJourneyUrl = new URL(mandatedJourneyUrl, window.location.origin)
        createMandatedJourneyUrl.searchParams.set('page_url', window.location.href)
        viewLearningJourneyBtn.setAttribute('href', createMandatedJourneyUrl.toString())
        viewLearningJourneyBtn.setAttribute('method', 'POST')
        viewLearningJourneyBtn.classList.remove('disabled')
      } else {
        console.error('Unable to fetch')
      }
    })
  }

  viewLearningJourneyBtnClicked(e) {
    e.preventDefault()

    const buttonHref = this.viewLearningJourneyBtnTarget.getAttribute('href')
    const method = this.viewLearningJourneyBtnTarget.getAttribute('method') || 'GET'
    if (method === 'GET') {
      window.location.href = buttonHref
      return
    }
    this.viewLearningJourneyBtnTarget.classList.add('creating-learning-journey')
    this.viewLearningJourneyBtnTarget.classList.add('disabled')

    const companyId = this.companyIdValue
    fetch(buttonHref,
      { method: 'POST', headers: { 'Accept': 'application/json', 'Authorization': `Bearer ${this.jwtValue}` } }
    ).then(async (response) => {
      if (response.ok) {
        const data = await response.json()
        window.location.href = `/companies/${companyId}/journeys/${data.id}`
      } else {
        console.error('Unable to create learning journey')
        Toastify({
          text: 'Something went wrong.',
          className: 'info',
          close: true,
          duration: 3000,
          style: {
            background: '#d81242'
          }
        }).showToast()
        this.viewLearningJourneyBtnTarget.classList.remove('creating-learning-journey')
        this.viewLearningJourneyBtnTarget.classList.remove('disabled')
      }
    })
  }
}
